import { deleteUserDataChanges } from '@/service/userdata-service';
import {
    childViewId,
    formViewName,
    getFocusedTab,
    getFuncChangeRoute,
    getHomeView,
    isTabReadyToSave,
    prepareChangesForSaving,
    removeTab,
    saveOpenedTabs,
    saveTabContent,
    setFocusedTab,
    tabState,
} from '../navigation-bars-data';
import router from '@/router';

export async function processTab(tab, index, dirtyTabs, saveFunc, isNeedSave) {
    let result = true;
    const remainingDirtyTabs = [...dirtyTabs];

    await getFuncChangeRoute()(tab);

    await new Promise(resolve => {
        const checkReadyState = () => {
            if (isTabReadyToSave) {
                resolve();
            } else {
                requestAnimationFrame(checkReadyState);
            }
        };
        checkReadyState();
    });

    if (isNeedSave) {
        try {
            const preparedData = await prepareChangesForSaving();
            const res = saveTabContent ? await saveTabContent(preparedData) : await saveFunc(preparedData);

            if (res) {
                tabState[window.location.pathname] = null;
                removeTab(tab);

                if (dirtyTabs.length === 1) {
                    const focusedTab = getFocusedTab();
                    if (tab.routePath === focusedTab.routePath) {
                        await router.push({ name: 'home-view' });
                        const homeView = getHomeView();
                        setFocusedTab(homeView);
                    }
                    removeTab(tab);
                    await saveOpenedTabs();
                }

                remainingDirtyTabs.splice(index, 1);
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    } else {
        const viewId = childViewId ?? formViewName;
        await deleteUserDataChanges({ viewId, uiRoute: window.location.pathname });
        tabState[window.location.pathname] = null;
        removeTab(tab);
        await saveOpenedTabs();
        remainingDirtyTabs.splice(index, 1);
    }

    if (index < remainingDirtyTabs.length) {
        const recurseRes = await processTab(remainingDirtyTabs[index], index, remainingDirtyTabs, saveFunc, isNeedSave);
        if (!recurseRes) {
            return recurseRes;
        }
    }

    return result;
}
